module.exports = __webpack_public_path__ + "img/logo.5297957f.png";